export enum BlogCategory {
    NEWS_SUMMARY = 'NEWS SUMMARY',
    UNCATEGORIZED = 'UNCATEGORIZED'
}
